const READY_TIMEOUT_MS = 5000;
const POLL_INTERVAL_MS = 250;

const syncThemeCart = async () => {
  try {
    const cart = await fetch("/cart.js", {
      headers: { Accept: "application/json" }
    }).then(r => r.json());
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:updated", { detail: { cart }, bubbles: true })
    );
  } catch (e) {
    console.error("[RebuyStore] Failed to sync theme cart", e);
  }
};

const RebuyStore = () => ({
  isEnabled: false,
  isReady: false,
  hasTimedOut: false,

  get isLoading() {
    return this.isEnabled && !this.isReady && !this.hasTimedOut;
  },
  get useRebuy() {
    return this.isEnabled && this.isReady;
  },
  get useCustom() {
    return !this.isEnabled || (this.hasTimedOut && !this.isReady);
  },

  init() {
    this.isEnabled = Boolean(window.themeVariables?.settings?.useRebuyCart);

    if (this.isEnabled) {
      const markReady = () => {
        if (!window.Rebuy?.SmartCart) return false;
        this.isReady = true;
        return true;
      };

      if (!markReady()) {
        document.addEventListener("rebuy:smartcart.ready", markReady, { once: true });

        let tries = 0;
        const maxTries = Math.ceil(READY_TIMEOUT_MS / POLL_INTERVAL_MS);
        const interval = setInterval(() => {
          if (markReady()) {
            clearInterval(interval);
          } else if (++tries >= maxTries) {
            clearInterval(interval);
            this.hasTimedOut = true;
          }
        }, POLL_INTERVAL_MS);
      }
    }

    document.addEventListener("rebuy:cart.change", syncThemeCart);
    document.addEventListener("rebuy:smartcart.line-item-increase", syncThemeCart);
    document.addEventListener("rebuy:smartcart.line-item-decrease", syncThemeCart);
    document.addEventListener("rebuy:smartcart.line-item-removed", syncThemeCart);
  }
});

export default RebuyStore;
